import { AxiosError } from 'axios'
import { createEffect } from 'effector'
import { AxiosErrorType } from '~/shared/api'

export const mapMessageErrors = (e: AxiosErrorType) => {
  const errorMessage = e.response?.data?.message
  return errorMessage ? errorMessage : 'Ошибка сервера.'
}

export const mapJsonApiMessageErrors = (e: AxiosErrorType) => {
  const errorMessage = e.response?.data?.errors
    ?.map((error) => error?.detail)
    .join(', ')
  return errorMessage || 'Ошибка сервера!'
}

export const mapErrorBlobToErrorType = async (
  e: AxiosError<Blob>,
): Promise<string> => {
  const errorBlob = e?.response?.data as Blob
  const errObj = JSON.parse(await errorBlob.text())
  return errObj?.errors || errObj.message || 'Ошибка сервера!'
}

export const mapErrorBlobToErrorTypeFx = createEffect(
  async (e: AxiosError<Blob>): Promise<string> => {
    return await mapErrorBlobToErrorType(e)
  },
)
